import type { SVGProps } from 'react';

interface GocoreLogoBallIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const GocoreLogoBallIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & GocoreLogoBallIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 36 36"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <path
      d="M2.842 27.235A17.57 17.57 0 0 1 0 17.624c0-2.222.41-4.344 1.157-6.304.575.18 1.164.363 1.747.543 2.669.826 4.615.764 5.32 1.81.335.492.166 4.521 0 8.423-.137 3.252-.932 3.535-3.66 4.506-.507.18-1.078.384-1.722.636zM13.38 34.747a17.55 17.55 0 0 1-9.558-6.144c2.163-.844 4.457-1.645 4.929-1.76.627-.148 1.278.15 2.177.564.427.197.912.421 1.48.632 1.427.536 1.327 1.794 1.237 2.903-.02.26-.041.512-.041.743 0 .505-.09 1.725-.224 3.059zM24.861 33.662a17.45 17.45 0 0 1-7.294 1.586q-1.614-.002-3.145-.28c.258-2.035.344-4.16.451-4.848l.007-.042q.008-.056.017-.107c.104-.674.141-.922.283-1.012.082-.052.437-.038.627-.032q.106.002.244.004c.393 0 1.932-.187 3.475-.37 1.543-.186 3.083-.37 3.476-.37.781 0 1.518 1.48 1.75 3.653q.11 1.015.116 1.818zM33.31 25.453a17.67 17.67 0 0 1-7.54 7.762 8 8 0 0 0-.134-1.375 50 50 0 0 0-.22-1.054c-.348-1.625-.589-2.751-.035-3.235.669-.584 3.803-2.143 5.746-2.875.833-.315 1.553.083 2.18.777zM28.436 3.781a17.61 17.61 0 0 1 6.696 13.844 18 18 0 0 1-.355 3.546c-2.638 1.877-6.152 3.823-7.464 4.34-1.95.768-1.911.032-1.787-2.166.01-.214.024-.446.034-.691.052-1.12.08-2.523.069-4.538.193-2.834.127-4.282.39-5.294.268-1.027.612-2.879 1.315-5.263.489-1.652.926-3.138 1.102-3.778M26.742 2.591q-.123.105-.262.215c-1.65 1.313-6.882 4.966-7.832 4.966s-2.38-.342-3.689-3.408c-.434-1.012-1.099-2.25-1.757-3.473l-.165-.304a17.6 17.6 0 0 1 4.522-.59c3.365 0 6.507.946 9.176 2.591zM1.764 9.916a17.65 17.65 0 0 1 9.392-8.705c.496 1.445 1.175 2.613 1.78 3.653.604 1.037 1.134 1.949 1.344 2.889.424 1.9-3.83 4.188-4.863 4.472-.49.135-1.102-.163-1.926-.563-.912-.443-2.087-1.013-3.64-1.258-.624-.1-1.34-.273-2.084-.491zM23.945 21.105c.245 2.764.462 5.2-1.505 5.757-1.994.564-4.984.436-6.727 0l-.72-.176c-1.949-.47-5.135-1.234-5.321-2.136-.437-2.122-.124-4.62.248-7.116.376-2.498.5-3.058 1.088-3.435.304-.19 1.278-1.213 2.294-2.274.975-1.02 1.984-2.077 2.473-2.477.569-.467 2.088.331 3.644 1.15l3.207 1.355c1.047.442 1.33 3.415 1.278 6.262-.02 1.12-.038 2.184.03 2.976l.011.11zM25.316 10.234c.455-1.172 2.267-6.003 1.164-5.675-1.098.325-7.76 4.593-6.3 5.08.26.086 1.902.657 2.188.764 1.33.497 2.573.798 2.948-.166z"
      fill="currentColor"
    />
  </svg>
);
